import React, { createContext, useContext, useEffect, useState, ReactElement } from 'react';
import { adapter, getAuthUser } from '@bforms-web/common'

export type AuthContextState = {
  isActive: boolean;
  isAdmin: boolean;
  isAuthenticated: boolean;
  isPatient: boolean;
  isLoading: boolean;
  user?: any;
};

export type AuthProviderProps = {
  children: ReactElement;
};

const defaultState: AuthContextState = {
  isActive: false,
  isAdmin: false,
  isAuthenticated: false,
  isPatient: false,
  isLoading: true,
  user: undefined,
};

export const AuthContext = createContext<AuthContextState>(defaultState);

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const [state, setState] = useState<AuthContextState>(defaultState);

  useEffect(() => {
    async function runAsync() {
      try {
        const token = localStorage.getItem('admToken')
        if(!token){
          setState({
            ...defaultState,
            isLoading: false,
          });
        }else{
          adapter.setBearerAuthorization(token);
        }
        
        const user = await getAuthUser.execute();
        if (!user) {
          localStorage.setItem('admToken', '');
          setState({
            ...defaultState,
            isLoading: false,
          });
        } else {
          setState({
            isActive: user.active,
            isAdmin: user.type.includes('ADMIN'),
            isAuthenticated: true,
            isPatient: user.type.includes('PATIENT'),
            isLoading: false,
            user,
          });
        }
      } catch (err) {
        setState({
          ...defaultState,
          isLoading: false,
        });
      }
    }
    runAsync();
  }, []);

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextState => useContext<AuthContextState>(AuthContext);
